import useSWR, { SWRConfiguration } from 'swr';
import { LegalForm, ProfitDetermination, SetupStatus, SkrRecommendation } from '../types';

export const setupStatusKey = (clubSlug?: string | null) => (clubSlug ? `invoice/${clubSlug}/setup/status` : null);

export const useSetupStatus = (clubSlug?: string | null, config: SWRConfiguration = {}) => {
    const { data, ...rest } = useSWR<{ data: SetupStatus }>(setupStatusKey(clubSlug), null, config);

    return { ...rest, status: data?.data };
};

export const useSkrRecommendation = (
    clubSlug?: string | null,
    legalForm?: LegalForm | '' | null,
    profitDetermination?: ProfitDetermination | null
) => {
    const { data, ...rest } = useSWR<{ data: SkrRecommendation }>(
        clubSlug && legalForm
            ? [
                  `invoice/${clubSlug}/setup/recommendation`,
                  {
                      legal_form: legalForm,
                      // the fetcher would send a missing value as the string "undefined"
                      ...(profitDetermination ? { profit_determination: profitDetermination } : {})
                  }
              ]
            : null,
        { keepPreviousData: true, revalidateOnFocus: false }
    );

    return { ...rest, recommendation: data?.data };
};

export default useSetupStatus;
